export const TRADUCAO = {
  pt: {
    translation: {
      carrossel: {
        item_1: {
          msg_destaque: "Somos o importador exclusivo da IWI no Brasil.",
          msg_destaque_bold: "Em nosso estoque: ",
          msg_texto: `  
              IWI Zion 5.56x45mm
              IWI Arad 7 7.62x51mm`,
          msg_texto_bold: "E mais...",
        },
        item_2: {
          msg_destaque: "Miras Meprolight",
          msg_destaque_bold: "ao seu alcance.",
          msg_texto: `Consulte nossos`,
          msg_texto_bold: "catálogos.",
        },
        item_3: {
          msg_destaque: "Confira nossa linha completa da",
          msg_destaque_bold: "Smith & Wesson",
          msg_texto: `pelo nosso`,
          msg_texto_bold: "WhatsApp.",
        },
        item_4: {
          msg_destaque: "Pistolas Steyr à",
          msg_destaque_bold: "PRONTA ENTREGA.",
          msg_texto: `Modelos:`,
          msg_texto_bold: `
              L9-A2 MF
              M9-A2 MF
              C9-A2 MF
              `,
        },
        item_5: {
          msg_destaque: "Pistolas Springfield à",
          msg_destaque_bold: "PRONTA ENTREGA.",
          msg_texto: `Modelos:`,
          msg_texto_bold: `
              Echelon 9mm 4.5F
              Echelon 9mm 4.0C
              Hellcat .380 OSP
              `,
        },
      },
      sobre_nos: {
        titulo: "Sobre nós",
        esquerdo: {
          dsc_texto_1:
            "Distribuição de PCE’s a pronta entrega em todo território nacional.",
          dsc_texto_2: "Estudos de viabilidade.",
          dsc_texto_3: "Estruturação e coordenação das operações.",
        },
        direito: {
          destaque:
            "Levamos as melhores marcas mundiais até você, conectando o Brasil ao que há de mais avançado no mercado internacional.",
          texto: {
            dsc_texto_1:
              "A BR Weapons se destaca pela excelência em importação, logística e vendas, garantindo qualidade, transparência e eficiência em cada etapa do processo.",
            dsc_texto_2:
              "Comprometidos em superar expectativas, marcamos presença nas principais feiras globais do tiro esportivo, acompanhando as inovações do setor.",
            dsc_texto_3:
              "Nossa equipe altamente qualificada assegura decisões rápidas e eficazes, proporcionando agilidade e segurança para o sucesso do seu negócio.",
          },
        },
      },
      onde_atuamos: {
        titulo: "Onde atuamos",
        brw_pelo_mundo: "BRWeapons pelo mundo!",
        paises: "Países",
        botao: "Descubra",
        limpar: "Limpar",
        voltar: "Voltar",
      },
      contato: {
        titulo: "Contato",
        texto: "Dúvidas? Por favor, entre em contato.",
        email: "Enviar e-mail",
        botao: "Enviar",
        inscrever: "Inscreva-se",
        newsletter: "Assine para receber as novidades!",
      },
      rodape: "© 2024 BR Weapons. Todos os direitos reservados.",
    },
  },
  en: {
    translation: {
      carrossel: {
        item_1: {
          msg_destaque: "We are the exclusive importer of IWI in Brazil.",
          msg_destaque_bold: "In our stock:",
          msg_texto: `
                        IWI Zion 5.56x45mm 
                        IWI Arad 7 7.62x51mm 
                      `,
          msg_texto_bold: "And more...",
        },
        item_2: {
          msg_destaque: "Meprolight sights",
          msg_destaque_bold: "sights at your fingertips.",
          msg_texto: `Check out`,
          msg_texto_bold: "our catalogs.",
        },
        item_3: {
          msg_destaque: "Check out our complete",
          msg_destaque_bold: "Smith & Wesson",
          msg_texto: `line on`,
          msg_texto_bold: "WhatsApp.",
        },
        item_4: {
          msg_destaque: "Steyr pistols available for ",
          msg_destaque_bold: "immediate delivery",
          msg_texto: `Models:`,
          msg_texto_bold: `
              L9-A2 MF
              M9-A2 MF
              C9-A2 MF
              `,
        },
        item_5: {
          msg_destaque: "Springfield pistols available for",
          msg_destaque_bold: "PRONTA ENTREGA.",
          msg_texto: `Modelos:`,
          msg_texto_bold: `
              Echelon 9mm 4.5F
              Echelon 9mm 4.0C
              Hellcat .380 OSP
              `,
        },
      },
      sobre_nos: {
        titulo: "ABOUT US",
        esquerdo: {
          dsc_texto_1:
            "Distribution of PCEs ready for delivery throughout the national territory. ",
          dsc_texto_2: "Feasibility studies.",
          dsc_texto_3: "Structuring and coordination of operations. ",
        },
        direito: {
          destaque:
            "We bring the best global brands to you, connecting Brazil to the most advanced in the international market.",
          texto: {
            dsc_texto_1:
              "BR Weapons stands out for its excellence in import, logistics and sales, ensuring quality, transparency and efficiency at every stage of the process.",
            dsc_texto_2:
              "Committed to exceeding expectations, we are present at the main global shooting sports fairs, following the sector's innovations.",
            dsc_texto_3:
              "Our highly qualified team ensures quick and effective decisions, providing agility and security for the success of your business.",
          },
        },
      },
      onde_atuamos: {
        titulo: "WHERE WE OPERATE",
        brw_pelo_mundo: "BRWeapons around the world!",
        paises: "Countries",
        botao: "Discover",
        limpar: "Clean",
        voltar: "Go back",
      },
      contato: {
        titulo: "CONTACT",
        texto: "Questions? Please contact us. ",
        email: "Send e-mail",
        botao: "Send",
        inscrever: "Subscribe",
        newsletter: "Subscribe to receive the latest news!",
      },
      rodape: "© 2024 BR Weapons. All rights reserved.",
    },
  },
  es: {
    translation: {
      carrossel: {
        item_1: {
          msg_destaque: "Representamos exclusivamente a IWI en Brasil.",
          msg_destaque_bold: "En nuestro stock:",
          msg_texto: `
              IWI Zion 5.56x45mm
              IWI Arad 7 7.62x51mm
              `,
          msg_texto_bold: "Y más...",
        },
        item_2: {
          msg_destaque: "Miras Meprolight ",
          msg_destaque_bold: "al alcance de su mano.",
          msg_texto: `Consulte nuestros`,
          msg_texto_bold: "catálogos.",
        },
        item_3: {
          msg_destaque: "Descubra toda nuestra línea de",
          msg_destaque_bold: "Smith & Wesson",
          msg_texto: `Wesson a través de`,
          msg_texto_bold: "WhatsApp!",
        },
        item_4: {
          msg_destaque: "Pistolas Steyr con",
          msg_destaque_bold: "ENTREGA INMEDIATA.",
          msg_texto: `Modelos:`,
          msg_texto_bold: `
              L9-A2 MF
              M9-A2 MF
              C9-A2 MF
              `,
        },
        item_5: {
          msg_destaque: "Pistolas Springfield con",
          msg_destaque_bold: "PRONTA ENTREGA.",
          msg_texto: `Modelos:`,
          msg_texto_bold: `
              Echelon 9mm 4.5F
              Echelon 9mm 4.0C
              Hellcat .380 OSP
              `,
        },
      },
      sobre_nos: {
        titulo: "SOBRE NOSOTROS",
        esquerdo: {
          dsc_texto_1:
            "Distribución de PCE’s a pronta entrega en todo el territorio nacional.",
          dsc_texto_2: "Estudios de viabilidad.",
          dsc_texto_3: "Estructuración y coordinación de las operaciones.",
        },
        direito: {
          destaque:
            "Acercamos las mejores marcas del mundo a usted, conectando a Brasil con lo último en el mercado internacional.",
          texto: {
            dsc_texto_1:
              "BR Weapons sobresale por su excelencia en importaciones, logística y ventas, asegurando calidad, transparencia y eficiencia en cada paso del camino.",
            dsc_texto_2:
              "Con el compromiso de superar expectativas, estamos presentes en los principales eventos globales de tiro deportivo, siempre atentos a las últimas tendencias del sector.",
            dsc_texto_3:
              "Nuestro equipo, altamente capacitado, toma decisiones rápidas y efectivas, ofreciendo agilidad y confianza para impulsar el éxito de su negocio.",
          },
        },
      },
      onde_atuamos: {
        titulo: "DONDE ACTUAMOS",
        brw_pelo_mundo: "BRWeapons por el mundo!",
        paises: "Países",
        botao: "Descubra",
        limpar: "Limpiar",
        voltar: "Volver",
      },
      contato: {
        titulo: "CONTACTO",
        texto: "Dudas? Por favor, póngase en contacto.",
        email: "Enviar e-mail",
        botao: "Enviar",
        inscrever: "Suscríbase",
        newsletter: "¡Suscríbase para recibir las novedades! ",
      },
      rodape: "© 2024 BR Weapons. Todos los derechos reservados.",
    },
  },
};
